module.exports = __webpack_public_path__ + "static/media/P200.181f84af.svg";